import { z } from 'zod'

export const uploadMappingsFormSchema = z.object({
  files: z
    .instanceof(FileList)
    .refine((list) => list.length > 0, 'You must upload at least 1 file.'),
})

// export the type with Typescript inference
export type UploadMappingsFormType = z.infer<typeof uploadMappingsFormSchema>
